import React from 'react';
import { Container, Typography, Paper, Box, Divider } from '@mui/material';
import Seo from '../components/common/Seo';

const Section = ({ title, children }) => (
    <Box sx={{ mt: 4 }}>
        <Typography variant="h6" fontWeight={700} gutterBottom>
            {title}
        </Typography>
        {children}
    </Box>
);

const P = ({ children }) => (
    <Typography variant="body1" paragraph sx={{ lineHeight: 2 }}>
        {children}
    </Typography>
);

function Privacy() {
    return (
        <>
            <Seo
                title="プライバシーポリシー"
                description="本サービスのプライバシーポリシーについて。個人情報の取り扱い方針を説明しています。"
                path="/privacy"
                keywords="プライバシーポリシー,個人情報保護,ルームシェアマッチング"
            />
            <Container maxWidth="md">
                <Paper sx={{ p: { xs: 3, md: 5 }, mt: 4, mb: 4 }}>
                    <Typography variant="h4" component="h1" gutterBottom fontWeight={700}>
                        プライバシーポリシー
                    </Typography>
                    <Typography variant="body2" color="text.secondary" gutterBottom>
                        制定：2024年3月1日　最終改訂：2026年4月12日
                    </Typography>
                    <Divider sx={{ mt: 2, mb: 3 }} />

                    <P>
                        本サービス提供者は、「ルームシェアマッチング」（以下「本サービス」といいます。）において取得するユーザーの個人情報を、以下の方針に従って取り扱います。本サービスを利用した時点で、本ポリシーの内容に同意したものとみなします。
                    </P>

                    <Section title="1. 収集する情報">
                        <P>
                            本サービスでは、サービス提供に必要な範囲で以下の情報を収集することがあります。<br />
                            ・アカウント登録時の情報（メールアドレス等）<br />
                            ・ユーザーが任意で登録するプロフィール情報（年齢・性別・居住地・ライフスタイル等）<br />
                            ・物件情報（ユーザーが自ら登録した情報）<br />
                            ・サービス利用履歴・アクセスログ<br />
                            ・デバイス情報・IPアドレス・ブラウザ情報<br />
                            ・クッキー等による行動ログ（詳細は第4条参照）
                        </P>
                    </Section>

                    <Section title="2. 情報の利用目的">
                        <P>
                            収集した情報は、以下の目的の範囲内で利用します。<br />
                            ・本サービスの提供・運営・改善<br />
                            ・ユーザー認証・本人確認<br />
                            ・ユーザーへの通知・お問い合わせ対応<br />
                            ・サービスの安全性確保・不正利用の防止<br />
                            ・利用状況の分析・統計処理（個人を特定しない形式）<br />
                            ・法令上の義務の履行
                        </P>
                    </Section>

                    <Section title="3. 第三者提供および業務委託">
                        <P>
                            本サービス提供者は、以下の場合に第三者へ情報を提供・共有することがあります。ユーザーはあらかじめこれに同意するものとします。<br /><br />
                            （1）業務委託先への提供<br />
                            本サービスは、認証基盤・クラウドデータベース・アクセス解析等、サービス提供に不可欠な外部クラウドサービスを利用しています。これらのサービス事業者には、サービス提供の目的に必要な範囲で情報が提供・処理されます。各外部サービスの個人情報取り扱いは、各社のプライバシーポリシーに従います。<br /><br />
                            （2）法令に基づく開示<br />
                            裁判所・警察・行政機関等から法令に基づく開示命令・照会があった場合。<br /><br />
                            （3）権利保護のための開示<br />
                            ユーザーまたは第三者の生命・身体・財産の保護のために必要であり、かつ本人の同意取得が困難な場合。<br /><br />
                            （4）事業承継<br />
                            合併・会社分割・事業譲渡等により事業が承継される場合。承継先は本ポリシーと同等の措置を講じるよう努めます。<br /><br />
                            上記以外の目的での第三者提供は、原則として行いません。ただし、本サービス提供者は、上記各号への該当について独自に判断する権限を有します。
                        </P>
                    </Section>

                    <Section title="4. クッキーおよびアクセス解析">
                        <P>
                            本サービスでは、以下の目的でクッキーその他の追跡技術を使用しています。<br />
                            ・ログイン状態の維持<br />
                            ・利用状況の分析（Google Analyticsを使用）<br />
                            ・サービス改善のための行動ログの取得<br /><br />
                            Google Analyticsの利用により、Cookieを通じた情報がGoogleに送信・処理されます。Googleによるデータ利用については、<a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Googleのプライバシーポリシー</a>をご参照ください。ブラウザの設定によりCookieを無効化することができますが、その場合、本サービスの一部機能が利用できなくなる場合があります。
                        </P>
                    </Section>

                    <Section title="5. 情報の保管および削除">
                        <P>
                            個人情報は、サービス提供に必要な期間、または法令で定められた保存義務期間のいずれか長い期間にわたり保持します。アカウント削除後は、技術的・運用上合理的な範囲で順次削除処理を行います。ただし、バックアップデータ・ログ等の性質上、即時の完全削除が困難な場合があり、本サービス提供者はその点について責任を負いません。
                        </P>
                    </Section>

                    <Section title="6. 国際的なデータ移転">
                        <P>
                            本サービスは、利用する外部クラウドサービスの性質上、ユーザーの情報が日本国外のサーバーで保存・処理される場合があります。本サービス提供者は、各外部サービスの利用規約・プライバシーポリシーの範囲内でのデータ取り扱いとなることをユーザーに周知するにとどまり、国際移転に起因する損害について責任を負いません。
                        </P>
                    </Section>

                    <Section title="7. セキュリティおよび漏洩に関する免責">
                        <P>
                            本サービス提供者は、不正アクセス・情報漏洩の防止に向けた合理的な技術的措置を講じるよう努めますが、完全なセキュリティを保証するものではありません。以下の事由により個人情報の漏洩・滅失・毀損等が生じた場合、本サービス提供者は一切の責任を負いません。<br />
                            ・ユーザー自身の操作上のミスや不注意による漏洩<br />
                            ・第三者による不正アクセス・ハッキング・マルウェア等<br />
                            ・外部クラウドサービスのセキュリティ侵害<br />
                            ・通信経路上での傍受その他技術的に防止が困難な事由<br />
                            ・その他本サービス提供者の故意または重大な過失によらない事由<br /><br />
                            ユーザーは、本サービスに登録する情報の範囲を自己の判断で選択し、必要以上の個人情報を登録しないよう努めるものとします。
                        </P>
                    </Section>

                    <Section title="8. ユーザーの権利">
                        <P>
                            ユーザーは、本サービス提供者に対し、自己の個人情報の開示・訂正・削除・利用停止を求めることができます。ただし、法令上の保存義務がある情報・技術的に削除が困難な情報については、要求に応じられない場合があります。また、対応には合理的な期間を要する場合があります。開示等の請求は、下記お問い合わせ先までご連絡ください。
                        </P>
                    </Section>

                    <Section title="9. プライバシーポリシーの変更">
                        <P>
                            本ポリシーは、法令の改正・サービス変更その他必要があると判断した場合に、ユーザーへの事前通知なく改定されることがあります。改定後のポリシーは、本サービス上に掲載した時点から効力を生じます。本サービスを継続利用したユーザーは、改定後のポリシーに同意したものとみなします。
                        </P>
                    </Section>

                    <Section title="10. お問い合わせ">
                        <P>
                            本ポリシーに関するお問い合わせは、本サービス内のお問い合わせフォーム、または下記メールアドレスよりご連絡ください。<br />
                            メールアドレス：roomsharematching@gmail.com
                        </P>
                    </Section>

                    <Box sx={{ mt: 4, p: 2, bgcolor: 'grey.50', borderRadius: 2 }}>
                        <Typography variant="body2" color="text.secondary">
                            本ポリシーに定める事項は、個人情報の保護に関する法律（個人情報保護法）その他の強行法規が優先する範囲において、当該法規の定めに従います。
                        </Typography>
                    </Box>
                </Paper>
            </Container>
        </>
    );
}

export default Privacy; 